export const appViews = {
  // ── VideoGuides.vue ──
  guides: {
    openCenter: "Otwórz centrum poradników",
    fabLabel: "Poradniki",
    assistantAria: "Asystent poradników",
    dontShowAgain: "Nie pokazuj ponownie",
    centerAria: "Centrum poradników",
    eyebrow: "CENTRUM PORADNIKÓW",
    title: "Poznaj WACheckin",
    watchedOf: "{watched} z {total} obejrzanych",
    close: "Zamknij",
    searchPlaceholder: "Szukaj poradnika…",
    forThisScreen: "Dla tego ekranu",
    watched: "Obejrzany",
    watchGuide: "Obejrzyj poradnik",
    comingSoon: "Wkrótce: nowe ulepszenia i aktualizacje.",
    noResults: "Brak wyników dla „{query}”.",
    needHelp: "Potrzebujesz pomocy? ",
    contactWhatsApp: "Napisz do nas na WhatsApp",
    lightboxMeta: "{section} · Poradnik {n} z {total}",
    videoTitle: "Film poradnikowy",
    playerAria: "Odtwarzacz poradników",
    prev: "Poprzedni",
    watchOnYouTube: "Obejrzyj na YouTube",
    next: "Następny",
    sections: {
      inicio: "Pierwsze kroki",
      alojamiento: "Twój obiekt",
      tarifas: "Ceny i kanały",
      calendario: "Kalendarz i rezerwacje",
      huesped: "Doświadczenie gościa",
      autoridades: "Służby",
      novedades: "Nowości",
    },
    videos: {
      navigate: "Dostęp i poruszanie się po ustawieniach",
      propertyData: "Dane obiektu, lokalizacja i branding",
      checkinWelcome: "Check-in, wiadomość powitalna i zasady",
      basePrices: "Ceny bazowe i stawki pochodne dla kanałów",
      calendar: "Kalendarz: rezerwacje, dostępność i ceny",
      guestJourney: "Ścieżka gościa: wiadomości, kody i automatyzacje",
      guestVerification: "Weryfikacja gościa i prośby o opinię",
      authorities: "Połącz służby i wysyłaj zgłoszenia o podróżnych",
    },
    ai: {
      cta: "Zobacz listę filmów",
      assistant: "Asystent",
      inicio: "Pierwszy dzień tutaj? Pokażę podstawy w 2 minuty.",
      alojamiento: "Konfigurujesz obiekt? Zobacz, jak ustawić wszystko jak należy.",
      tarifas: "Pytania o ceny? Wyjaśnię stawki w poszczególnych kanałach.",
      calendario: "Chcesz opanować kalendarz? Rezerwacje, ceny i dostępność.",
      huesped: "Zautomatyzujemy ścieżkę gościa? Pokażę krok po kroku.",
      autoridades: "Połączymy służby? Zgłoszenia o podróżnych w 1 filmie.",
    },
  },
  // ── NovedadesDrawer.vue ──
  news: {
    ariaPanel: "Nowości w systemie",
    latestUpdates: "Najnowsze aktualizacje",
    close: "Zamknij",
    tabNews: "Nowości",
    reports: "Zgłoszenia",
    loading: "Wczytywanie…",
    emptyNews: "Nie ma jeszcze nowości. Ulepszenia pojawią się tutaj, gdy tylko je opublikujemy.",
    showMore: "Pokaż więcej",
    showLess: "Pokaż mniej",
    reportProblem: "Zgłoś problem",
    emptyReports: "Nie wysłano jeszcze żadnego zgłoszenia.",
    sendReport: "+ Wyślij zgłoszenie",
    sendNewReport: "+ Wyślij nowe zgłoszenie",
    capturesCount: "{count} zrzut ekranu | {count} zrzuty ekranu | {count} zrzutów ekranu",
    viewConversation: "Zobacz rozmowę →",
    new: "Nowe",
    openedOn: "otwarte {date}",
    conversationWithSupport: "Rozmowa z zespołem wsparcia",
    you: "Ty",
    support: "Wsparcie",
    noReplyYet: "Nikt z zespołu jeszcze nie odpowiedział. Damy znać w tym miejscu, gdy tylko to nastąpi.",
    replyPlaceholder: "Napisz odpowiedź…",
    send: "Wyślij",
    replyHint: "<b>Enter</b> wysyła · <b>Shift + Enter</b> nowa linia",
    back: "Wstecz",
    sendReportTitle: "Wyślij zgłoszenie",
    formSubtitle: "Napisz, co się stało, a my to sprawdzimy. Odpowiedź zobaczysz w swoich zgłoszeniach.",
    about: "Dotyczy",
    whatHappens: "Co się dzieje?",
    titlePlaceholder: "Opisz to w jednym zdaniu",
    describeDetail: "Opisz szczegółowo",
    descPlaceholder: "Jaki był oczekiwany efekt, co się wydarzyło i jak to powtórzyć.",
    capture: "Zrzut ekranu",
    optional: "opcjonalnie",
    attachHint: "Dotknij, aby dołączyć obraz",
    sending: "Wysyłanie…",
    submitReport: "Wyślij zgłoszenie",
    prev: "Poprzednie",
    next: "Następne",
    today: "Dzisiaj",
    yesterday: "Wczoraj",
    status: {
      open: "Otwarte",
      in_progress: "W trakcie",
      resolved: "Rozwiązane",
      closed: "Zamknięte",
    },
    errRequired: "Napisz, co się dzieje.",
    errSend: "Nie udało się wysłać. Spróbuj ponownie.",
  },
  // ── VerifyIdentity.vue ──
  verify: {
    title: "Weryfikacja tożsamości",
    subtitle: "Aby dokończyć check-in, musimy zweryfikować Pana/Pani tożsamość",
    idDocument: "Dokument tożsamości",
    idDocumentDesc: "Prosimy zrobić wyraźne zdjęcie przedniej strony dokumentu (DNI, NIE, dowód osobisty, paszport lub prawo jazdy)",
    selfie: "Selfie",
    selfieDesc: "Prosimy zrobić selfie, na którym twarz jest dobrze widoczna",
    requirements: "Wymagania:",
    req1: "Dobre oświetlenie",
    req2: "Cały dokument w kadrze",
    req3: "Czytelny tekst",
    req4: "Selfie bez akcesoriów zasłaniających twarz",
    start: "Rozpocznij weryfikację",
    frontTitle: "Przednia strona dokumentu",
    alignDocument: "Prosimy ustawić dokument w ramce",
    hintLegible: "Prosimy upewnić się, że wszystkie dane są czytelne",
    faceTitle: "Weryfikacja twarzy",
    alignFace: "Prosimy ustawić twarz w okręgu",
    hintLookCamera: "Prosimy patrzeć prosto w kamerę, bez akcesoriów",
    reviewTitle: "Prosimy sprawdzić zdjęcia",
    reviewSubtitle: "Prosimy sprawdzić, czy wszystkie zdjęcia są wyraźne i czytelne",
    frontDocTitle: "Przednia strona dokumentu",
    retake: "Zrób ponownie",
    back: "Wstecz",
    submit: "Wyślij do weryfikacji",
    processingTitle: "Weryfikujemy tożsamość",
    processingDesc: "Sprawdzamy dokumenty. Może to potrwać kilka sekund...",
    dontClose: "Prosimy nie zamykać tego okna",
    successTitle: "Weryfikacja zakończona pomyślnie!",
    successDesc: "Tożsamość została pomyślnie zweryfikowana.",
    continue: "Kontynuuj",
    errorTitle: "Błąd weryfikacji",
    couldNotVerify: "Nie udało się zweryfikować tożsamości. Prosimy spróbować ponownie.",
    retry: "Ponów",
    cameraErrorTitle: "Brak dostępu do kamery",
    cameraErrorDesc: "Nie udało się uzyskać dostępu do kamery. Prosimy sprawdzić uprawnienia i spróbować ponownie.",
    suggestions: "Podpowiedzi:",
    tip1: "Prosimy upewnić się, że dostęp do kamery został przyznany",
    tip2: "Prosimy sprawdzić, czy kamery nie używa inna aplikacja",
    tip3: "Prosimy ponownie uruchomić przeglądarkę, jeśli problem się powtarza",
    tryAgainCamera: "Spróbuj ponownie",
    couldNotVerifyShort: "Nie udało się zweryfikować tożsamości",
    serverError: "Błąd serwera",
    tryLater: "Prosimy spróbować później",
  },
};
